export const AutoLockFormsLevelType = {
  PAGE: 'page',
  SECTION: 'section',
  SUBSECTION: 'subsection',
  TAB: 'tab',
  FORM: 'form',
  FIELD: 'field',
};

export const AREA_ID_PREFIX = {
  [AutoLockFormsLevelType.PAGE]: 'page:',
  [AutoLockFormsLevelType.SECTION]: 'section:',
  [AutoLockFormsLevelType.SUBSECTION]: 'subsection:',
  [AutoLockFormsLevelType.TAB]: 'tab:',
};

export const AutoLockPageCodes = {
  LOAN_EDITOR: 'loanEditor',
  ACTIONS: 'actions',
};

export const ActionsFieldNames = {
  PROGRAM_CHANGE: 'programChange',
};

export const LoanEditorSectionNames = {
  PROPERTY_AND_LOAN: 'propertyAndLoan',
  BORROWERS: 'borrowers',
  FEES: 'fees',
  UNDERWRITING: 'underwriting',
  CLOSING: 'closing',
  FINANCIAL_INFO: 'financialInfo',
  LEAD: 'lead',
  ACTIVITIES: 'activities',
  TASKS: 'tasks',
};

export const FinancialInfoSubsectionNames = {
  EMPLOYMENT_INFO: 'employmentInfo',
  LIABILITIES: 'liabilities',
  REO: 'reo',
  ASSETS: 'assets',
};

export const PropertyAndLoanSubsectionNames = {
  PROPERTY_INFO: 'propertyInfo',
  LOAN_AND_LOCK_INFO: 'loanAndLockInfo',
  CONTACTS: 'contacts',
};

export const BorrowersSubsectionNames = {
  BORROWERS: 'borrowers',
  NON_BORROWERS: 'nonBorrowers',
};

export const FeesSubsectionNames = {
  Fees: 'fees',
};

export const LeadSubsectionNames = {
  LeadDetails: 'leadDetails',
};

export const ActivitiesSubsectionNames = {
  ACTIVITIES: 'activities',
};

export const TasksSubsectionNames = {
  TASKS: 'tasks',
};

export const ClosingSubsectionNames = {
  CLOSING_INFORMATION: 'closingInformation',
  CLOSING_COMPANIES: 'closingCompanies',
  TITLE_HOLDER: 'titleHolder',
  FUNDING_INFORMATION: 'fundingInformation',
  POST_CLOSING: 'postClosing',
};

export const UnderwritingSubsectionNames = {
  NOTES: 'notes',
  GENERAL: 'general',
  DOCUMENT_EXPIRATION_DATES: 'documentExpirationDates',
  CONDITIONS: 'conditions',
  DENIAL_REASONS: 'denialReasons',
};

export const LoanAndLockInfoTabNames = {
  ADDITIONAL_FINANCING: 'additionalFinancing',
  CREDITS: 'credits',
  LOCK_INFO: 'lockInfo',
  LOAN_INFO: 'loanInfo',
  // Not a tree tab (it holds no lockable fields) — only a checklist link target (LEN2-499).
  PROGRAMS_PRICING: 'programsPricing',
};

export const PropertyInfoTabNames = {
  PROPERTY: 'property',
  APPRAISAL: 'appraisal',
  PROPERTY_EXPENSES: 'propertyExpenses',
  PROJECT: 'project',
  TRANSACTION_DETAILS: 'transactionDetails',
  AGENT_AND_SELLER: 'agentAndSeller',
};

export const BorrowersTabNames = {
  BORROWER: 'borrower',
  ADDRESS: 'address',
  CREDIT_REPORTING: 'creditReporting',
  ALTERNATE_NAMES: 'alternateNames',
  POA: 'poa',
  DECLARATIONS: 'declarations',
};

export const NonBorrowersTabNames = {
  NBE_INFO: 'nbeInfo',
};

export const FeesTabNames = {
  FEES: 'fees',
};

export const LeadTabNames = {
  PERSONAL_INFORMATION: 'personalInformation',
  LOAN_INFORMATION: 'loanInformation',
  PROPERTY_INFORMATION: 'propertyInformation',
};

export const ActivitiesTabNames = {
  EMAILS: 'emails',
  CALLS: 'calls',
};

export const TasksTabNames = {
  ASSIGN_TASK: 'assignTask',
  TASK_INFORMATION: 'taskInformation',
};

export const IncomesTabNames = {
  INCOME_AND_EMPLOYMENT: 'incomeAndEmployment',
};

export const LiabilitiesTabNames = {
  LIABILITIES: 'liabilities',
};

export const ReoTabNames = {
  REO: 'reo',
};

export const AssetsTabNames = {
  ASSETS: 'assets',
};

export const TitleHolderTabNames = {
  GENERAL: 'general',
  TITLE_HOLDER_INFORMATION: 'titleHolderInformation',
  TRUST: 'trust',
  TRUSTEE_SETTLOR_BENEFICIARY: 'trusteeSettlorBeneficiary',
};

export const ClosingInformationTabNames = {
  GENERAL: 'general',
};

export const ClosingCompanyTabNames = {
  COMPANY_INFORMATION: 'companyInformation',
  CLOSER_INFORMATION: 'closerInformation',
  ADD_PROVIDER_LOCATION: 'addProviderLocation',
  ADD_FEE_PROVIDER: 'addFeeProvider',
};

export const FundingInformationTabNames = {
  FUNDING_INFORMATION: 'fundingInformation',
  CLOSING_AGENT: 'closingAgent',
  WIRE_TO_INFORMATION: 'wireToInformation',
  FURTHER_CREDIT_TO: 'furtherCreditTo',
};

export const PostClosingTabNames = {
  SHIPPING_INFORMATION: 'shippingInformation',
  INVESTOR: 'investor',
  ACCOUNTING_INFORMATION: 'accountingInformation',
  SERVICER_INFORMATION: 'servicerInformation',
  PAYMENT_INFORMATION: 'paymentInformation',
  DOCUMENTS_LIST: 'documentsList',
  FINAL_DOCUMENTS: 'finalDocuments',
  SHIPPER_MILESTONE: 'shipperMilestone',
  MERS_INFORMATION: 'mersInformation',
  FLIPPED_UNSALABLE: 'flippedUnsalable',
};

export const NotesTabNames = {
  NOTES: 'notes',
};

export const GeneralTabNames = {
  GENERAL: 'general',
};

export const DocumentExpirationDatesTabNames = {
  DOCUMENT_EXPIRATION_DATES: 'documentExpirationDates',
};

export const DenialReasonsTabNames = {
  DENIAL_REASONS: 'denialReasons',
};

export const ConditionsModalNames = {
  ADD_CONDITIONS_AND_CONDITIONS_SETS: 'addConditionsAndConditionsSets',
  ADD_CONDITION: 'addCondition',
  TASK_INFO: 'taskInfo',
};

export const ContactsTabNames = {
  CONTACTS: 'contacts',
};

// Tree field names whose rendered field carries a `data-field-id` marker because its DOM
// `name` differs from the tree's (see autoLockForms.fieldIds.js, LEN2-499).
export const NotesFieldNames = {
  NOTES: 'notes',
};

export const DenialReasonsFieldNames = {
  NEW_DENIAL_REASON: 'newDenialReason',
  BORROWER_SELECTION: 'borrowerSelection',
};

export const ActivitiesCallsFieldNames = {
  CALL_OUTCOME: 'callOutcome',
};

export const ActivitiesEmailsFieldNames = {
  BODY: 'body',
  FILES: 'files',
};

export const NonBorrowerInfoFieldNames = {
  CELL_PHONE_NUMBER: 'cellPhoneNumber',
};

export const FormNames = {
  ADDRESS_FIELDS: 'addressFieldsForm',
  PROPERTY_ADDRESS: 'propertyAddressForm',
  APPRAISAL: 'appraisalForm',
  PROPOSED_PROPERTY_EXPENSES: 'proposedPropertyExpensesForm',
  PROPERTY_TAXES: 'propertyTaxesForm',
  SUPPLEMENTAL_INSURANCES: 'supplementalInsurancesForm',
  OTHER_EXPENSES: 'otherExpensesForm',
  PROJECT: 'projectForm',
  TRANSACTION_DETAILS: 'transactionDetailsForm',
  AGENT: 'agentForm',
  LISTING_AGENT: 'listingAgentForm',
  SELLER: 'sellerForm',
  EXISTING_PROPERTY_EXPENSES: 'existingPropertyExpensesForm',
  LOAN_DETAILS: 'loanDetailsForm',
  ADDITIONAL_LOAN_INFO: 'additionalLoanInfoForm',
  CUSTOM_ADJUSTMENTS: 'customAdjustmentsForm',
  ADD_EXTENSION: 'addExtensionForm',
  SELL_SIDE_LOCK: 'sellSideLockForm',
  ADDITIONAL_FINANCING: 'additionalFinancingForm',
  CREDITS: 'creditsForm',
  BORROWER_INFO: 'borrowerInfoForm',
  BORROWER_ADDRESS: 'borrowerAddressForm',
  CREDIT_REPORTING: 'creditReportingForm',
  ALTERNATE_NAMES: 'alternateNamesForm',
  POA: 'poaForm',
  DECLARATIONS: 'declarationsForm',
  NON_BORROWER_INFO: 'nonBorrowerInfoForm',
  FEES: 'feesForm',
  NOTES: 'notesForm',
  UNDERWRITING_GENERAL: 'underwritingGeneralForm',
  UNDERWRITING_DOCUMENT_EXPIRATION_DATES: 'underwritingDocumentExpirationDatesForm',
  ADD_CONDITIONS_AND_CONDITIONS_SETS: 'addConditionsAndConditionsSetsForm',
  ADD_CONDITION: 'addConditionForm',
  CONDITIONS_TASK_INFO: 'conditionsTaskInfoForm',
  CLOSING_INFORMATION: 'closingInformationForm',
  CLOSING_COMPANY_INFORMATION: 'closingCompanyInformationForm',
  ADD_PROVIDER_LOCATION: 'addProviderLocationForm',
  ADD_FEE_PROVIDER: 'addFeeProviderForm',
  TITLE_HOLDER_GENERAL: 'titleHolderGeneralForm',
  TITLE_HOLDER_INFORMATION: 'titleHolderInformation',
  FUNDING_INFORMATION: 'fundingInformationForm',
  POST_CLOSING: 'postClosingForm',
  EMPLOYMENT_INCOME: 'employmentIncomeForm',
  LIABILITIES: 'liabilitiesForm',
  REO: 'reoForm',
  ASSETS: 'assetsForm',
  LEAD: 'leadForm',
  ACTIVITIES_EMAILS: 'activitiesEmailsForm',
  ACTIVITIES_CALLS: 'activitiesCallsForm',
  TASK_INFORMATION: 'tasksInformationForm',
  ASSIGN_TASK: 'assignTaskForm',
  DENIAL_REASONS: 'denialReasonsForm',
  EMPLOYMENT_VERIFICATION: 'employmentVerificationForm',
  DOCUMENT_VERIFICATION_TYPES: 'documentVerificationTypesForm',
  CONTACTS: 'contacts',
  CHATTEL_PROPERTY: 'chattelPropertyForm',
  CHATTEL_HOME_DETAILS: 'chattelHomeDetailsForm',
  CHATTEL_PROPERTY_EXPENSES: 'chattelPropertyExpensesForm',
  MORTGAGE_INSURANCE: 'mortgageInsuranceForm',
};
